import { Container } from "@mui/material";
import React from "react";
import { Box, Button, Grid, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import Sella from "./Sella.png";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useEffect } from "react";

const Intestazione = styled(Box)({
    fontFamily: "Montserrat, sans-serif",
    fontSize: "31px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "center",
    color: "#1b1b1b",
});

const CompilaCampi = styled(Box)({
    fontFamily: "Lato",
    fontSize: "15px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.11px",
    textAlign: "center",
    color: "#7b7b7b",
});

const SelectUser = styled(Box)({
    fontFamily: 'Lato',
    fontSize: '18px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: '0.13px',
    textAlign: 'center',
    color: '#4d606f'
});
const UserList = styled(Grid)({
    marginTop: "5px",
});

const ListaUsers = styled(FormControl)({
    textAlign: "center",
});

const ElementoLista = styled(FormControlLabel)({
    fontFamily: "Lato",
    fontSize: "15px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#4d606f",
    textAlign: "center",
});
const SelezioneUser = styled(RadioGroup)({
    textAlign: "center",
});

const SimpleBox = styled(Box)({
    textAlign: "center",
});
const SendEmailButton = styled(Button)({
    fontFamily: "Lato",
    fontSize: "16px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.11px",
    color: "#339aef",
    textTransform: "none",
    marginTop: '39px'
});

const HelperText = styled(Box)({
    marginTop: "168px",
    fontFamily: "Lato",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.54",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#919191",
});

const ContactLink = styled(Link)({
    fontFamily: "Lato",
    fontSize: "13px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.54",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#00cb4d",
});

const Informativa = styled(Box)({
    marginBottom: '35px',
    opacity: "0.5",
    fontFamily: "Lato",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.09px",
    textAlign: "center",
    color: "#333",
});

function PrintUserOrCode() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    return (
        <Container>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <img src={Sella}></img>
                </Grid>
            </Grid>
            <br></br>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
                </Grid>
            </Grid>
            <br></br>
            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <CompilaCampi>
                        Compila i campi per recuperare il Codice Cliente o Username
                    </CompilaCampi>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={0} sm={0} md={3}></Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <div class="Line-8"></div>
                </Grid>
                <Grid item xs={0} sm={0} md={3}></Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <SelectUser>Scegli lo Username che vuoi recuperare</SelectUser>
                </Grid>
            </Grid>

            <UserList container spacing={5}>
                <Grid item xs={0} sm={0} md={4}></Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <SimpleBox>
                        <ListaUsers>
                            <SelezioneUser>
                                <ElementoLista
                                    value="user"
                                    control={<Radio />}
                                    label="Ma********no"
                                />
                                <ElementoLista
                                    value="user2"
                                    control={<Radio />}
                                    label="mE*********55"
                                />
                                <ElementoLista
                                    value="user3"
                                    control={<Radio />}
                                    label="Rx********13"
                                />
                            </SelezioneUser>
                        </ListaUsers>
                    </SimpleBox>
                </Grid>
                <Grid item xs={0} sm={0} md={4}></Grid>
            </UserList>

            <Grid container>
                <Grid item xs={0} sm={0} md={4}></Grid>
                <Grid item xs={12} sm={12} md={4}>
                    <SimpleBox>
                        <SendEmailButton>Inviami i codici via email</SendEmailButton>
                    </SimpleBox>
                    <Grid item xs={0} sm={0} md={4}></Grid>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <HelperText>
                        Vuoi maggiori informazioni o hai bisogno di assistenza?
                    </HelperText>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <SimpleBox>
                        <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
                    </SimpleBox>
                </Grid>
            </Grid>

            <Grid container>
                <Grid item xs={0} sm={0} md={3}></Grid>
                <Grid item xs={12} sm={12} md={6}>
                    <div class="Line-8"></div>
                </Grid>
                <Grid item xs={0} sm={0} md={3}></Grid>
            </Grid>

            <Grid container>
                <Grid item xs={12} sm={12} md={12}>
                    <Informativa>
                        © 1996-2018 - Banca Sella S.p.A. - PI 02224410023 - Privacy
                    </Informativa>
                </Grid>
            </Grid>


        </Container >
    );
}

export default PrintUserOrCode;